// Curated, skippable. Brief §13: short punchy lines, sales / discipline /
// focus, "tone: confident coach, not Duolingo owl." AI-generated rotation
// is Phase 3 — these stay hardcoded for now.

export const QUOTES: readonly string[] = [
  'Pressure on. Keep dialling.',
  'Easy is the enemy. Next number.',
  'Don’t think. Dial.',
  'Three calls before you breathe.',
  'Slow is smooth. Smooth is fast.',
  'Tom is still going.',
  'Bang it out before lunch.',
  'Talk less. Dial more.',
  'Pick up the phone.',
  'Stay sharp on the next one.',
  'Your average is dropping. Sharper today.',
  'Keep your head in this one.',
  'They want to be sold to.',
  'Pace, not panic.',
  'One more before you stop.',
  'You’re halfway. Finish strong.',
];
